<template>
  <base-popover popover-type="tooltip" :content-style="{ maxWidth: 'unset' }">
    <template #content>
      <div class="popover-content">
        <div class="popover-content-row">
          <span class="row-title">
            {{ $t('b2b|common|label|operation_limit') }}
          </span>
          <span class="row-value light">
            {{ formatFiatAmount(transactionLimitMin) }} -
            {{ formatFiatAmount(transactionLimitMax) }}
          </span>
        </div>

        <div class="popover-content-row">
          <span class="row-title">
            {{ $t('Daily limit') }}
          </span>
          <span class="row-value">
            {{
              $t('InputCoinAmount | out of', {
                left: formatFiatAmount(dayLimitLeft),
                full: formatFiatAmount(dayLimitFull),
              })
            }}
          </span>
        </div>

        <div class="popover-content-row">
          <span class="row-title">
            {{ $t('b2b|common|label|monthly_limit') }}
          </span>
          <span class="row-value">
            {{
              $t('InputCoinAmount | out of', {
                left: formatFiatAmount(monthLimitLeft),
                full: formatFiatAmount(monthLimitFull),
              })
            }}
          </span>
        </div>
      </div>
    </template>
  </base-popover>
</template>

<script>
import { BasePopover } from '@emcd-shared/base-popover'
import Utils from '@emcd-shared/utils/formatters'

export default {
  components: { BasePopover },
  props: {
    transactionLimitMin: [Number, undefined],
    transactionLimitMax: [Number, undefined],
    dayLimitFull: [Number, undefined],
    dayLimitLeft: [Number, undefined],
    monthLimitFull: [Number, undefined],
    monthLimitLeft: [Number, undefined],
    // Object with description of selected fiat from config
    fiat: [Object, undefined],
  },

  methods: {
    formatFiatAmount(value) {
      if (value === undefined || this.fiat === undefined) return ''
      return Utils.formatCurrency(
        value,
        this.fiat?.value,
        0,
        false,
        'floor',
        {},
        this.$i18n.locale
      )
    },
  },
}
</script>

<style scoped lang="scss">
.popover-content {
  min-width: 100px;
  padding: 15px;
}

.popover-content-row {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  font-size: 12px;
  line-height: 18px;
}

.row-title {
  color: var(--text-3);
}

.row-value {
  color: var(--text-3);
  display: flex;
  gap: 5px;
}

.light {
  color: var(--text-1);
}
</style>
